import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';

export interface SalesByPeriodPrintingResult extends ReportPrintResult { }

export interface SalesByPeriodPrintingParameters extends ReportPrintQueryParameters { }

export class SalesByPeriodPrintingQuery extends ReportPrintQuery<SalesByPeriodPrintingResult> {
    public constructor(parameters: SalesByPeriodPrintingParameters) {
        super(parameters);
    }
}

export class SalesByPeriodPrintingQueryHandlerBase implements QueryHandler<SalesByPeriodPrintingQuery, SalesByPeriodPrintingResult> {
    private static Url = TaggedUrl.join('salesByPeriod/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SalesByPeriodPrintingQuery): Promise<SalesByPeriodPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'SprzedazWOkresie'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(SalesByPeriodPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });
        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
